import async from 'components/Async';
import { access } from 'constants/index';

const FormikFormPage = async(() => import('./FormikForm'));

const adminDeveloperRouteList = [
   {
      path: '/admin/developer/formik-form',
      component: FormikFormPage,
   },
];

const routeListToExport = process.env.NODE_ENV === 'development'
   ? adminDeveloperRouteList.map((routeItem) => ({
      ...routeItem,
      access: access.byRole.employer.onlyAdmin,
   }))
   : [];

export default routeListToExport;
